import { render, staticRenderFns } from "./CustomerInfoCard.vue?vue&type=template&id=0eb3370e"
import script from "./CustomerInfoCard.vue?vue&type=script&lang=js"
export * from "./CustomerInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports